import React from "react";
import { Path } from "react-static-google-map";
import { Site } from "../../types/site";

type Props = {
  site: Site;
};

const SiteRectangle: React.FC<Props> = ({ site }) => {
  return (
    <Path
      weight="2"
      color="0x14126f"
      fillcolor="0x14126f"
      points={[
        { lat: site.southExtremity, lng: site.westExtremity },
        { lat: site.northExtremity, lng: site.westExtremity },
        { lat: site.northExtremity, lng: site.eastExtremity },
        { lat: site.southExtremity, lng: site.eastExtremity },
        { lat: site.southExtremity, lng: site.westExtremity },
      ]}
      key={`site-${site.id}`}
    />
  );
};

export default SiteRectangle;
